import axios from 'axios';
import store from '../store'
import verifyAuth from '../services/utilities' 

class LinkedPlatformRepository {
    constructor(){
        this.basePath = store.state.backend;
    }

    allLinkedPlatformsOfUser() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/linked-platform`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getAvailablePlatforms() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/platforms/integrations`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    async verifyPluginConnection(platformName) {
        const response = await this.allLinkedPlatformsOfUser();
        
        if (response.status < 400) {
            const linkedPlugins = response.data.filter(
                link => link.platform.integrationType === 'PLUGIN'
            );
            
            // Keep the exact platform name for comparison
            const platformConnected = linkedPlugins.some(
                link => link.platform.name === platformName
            );

            // eslint-disable-next-line no-console
            console.log('Checking platform:', platformName);
            // eslint-disable-next-line no-console
            console.log('Available platforms:', linkedPlugins.map(p => p.platform.name));
            
            return {
                status: 200,
                data: {
                    success: platformConnected,
                    totalTrades: platformConnected ? 0 : null // We don't get trade count in this response
                }
            };
        }
        
        return response;
    }
}

export default new LinkedPlatformRepository();
